import type { Install, InstallDay, Job, Quote } from "../hooks/slice-a";

export type JobHistoryEntry = { at:string; kind:"key"|"money"|"plain"; title:string; detail?:string };
const valid = (value:string|null|undefined):value is string => !!value && Number.isFinite(Date.parse(value));

/** A next date and a count do not describe the intervening calendar days. */
export function recordedInstallDays(rows:Install[]|undefined):InstallDay[] {
  return (rows??[]).flatMap(i=> {
    if(i.days?.length)return i.days.filter(d=>valid(d.date)).map(d=>({...d,done:valid(d.done)?d.done:null}));
    return valid(i.next_date)?[{id:null,date:i.next_date,crew:i.team,task:"Next scheduled date · full schedule not connected",done:null}]:[];
  }).sort((a,b)=>a.date.localeCompare(b.date));
}

/** Saved dates describe records, unless an explicit event supplies stronger evidence. */
export function jobRecordHistory(job:Job,quotes:Quote[],days:InstallDay[]):JobHistoryEntry[] {
  const rows:JobHistoryEntry[]=[];
  if(valid(job.creation_date))rows.push({at:job.creation_date,kind:"key",title:"Job record created"});
  for(const q of quotes)if(valid(q.created_at))rows.push({at:q.created_at,kind:"money",title:"Quote record created",detail:q.option_name??"Option"});
  if(valid(job.deposit_date))rows.push({at:job.deposit_date,kind:"money",title:"Deposit date recorded",detail:"Received amount is not available here"});
  for(const d of days){
    rows.push({at:d.date,kind:"plain",title:"Scheduled date",detail:[d.task,d.crew].filter(Boolean).join(" · ")});
    if(valid(d.done))rows.push({at:d.done,kind:"key",title:"Day completion recorded",detail:[d.task,d.crew].filter(Boolean).join(" · ")});
  }
  if(valid(job.close_date))rows.push({at:job.close_date,kind:"key",title:"Close date recorded",detail:"This date alone does not confirm installation completion"});
  if(valid(job.date_paid))rows.push({at:job.date_paid,kind:"money",title:"Paid date recorded",detail:"Saved date, not a payment transaction; see Payment records from Xero"});
  return rows;
}
